export enum ErrorMessage {
  Unauthorized = "Sign In to Unlock CleverMail Features. Once signed in, please refresh Gmail to activate the magic of CleverMail.",
  ConsentIsNeeded = "Consent is needed",
}

export enum ErrorReason {
  Unauthorized = "Unauthorized",
  ConsentIsNeeded = "Consent is needed",
}
